import React from 'react';

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const DoorsSection = () => (
  <section className="doors" data-testid="doors-section">
    <div className="door-grid">
      {/* For organisations */}
      <div className="door org" id="organisations">
        <span className="eyebrow">For organisations</span>
        <h2>You have people to house.</h2>
        <p>Councils, housing providers, care and supported-living providers, charities and employers with an identifiable accommodation requirement.</p>
        <ul>
          <li>
            <b>Accommodation solutions</b>
            <span>Sourcing, providing and managing accommodation for corporate, temporary, supported and specialist requirements.</span>
          </li>
          <li>
            <b>Serviced and managed accommodation</b>
            <span>Short, medium and extended stays for corporate, project and relocation needs.</span>
          </li>
          <li>
            <b>Strategic accommodation partnerships</b>
            <span>Longer-term arrangements built around a defined, ongoing requirement.</span>
          </li>
        </ul>
        <a className="btn btn-gold" href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} data-testid="doors-org-cta">
          Discuss a requirement &rarr;
        </a>
      </div>

      {/* For property owners */}
      <div className="door own" id="owners">
        <span className="eyebrow">For property owners</span>
        <h2>You have a property to put to work.</h2>
        <p>Landlords, investors and organisations who want their property run properly without carrying the day-to-day themselves, including owners based overseas.</p>
        <ul>
          <li>
            <b>Property operations and management</b>
            <span>Day-to-day operations, occupancy, maintenance coordination, contractor management and performance oversight.</span>
          </li>
          <li>
            <b>Landlord management solutions</b>
            <span>For landlords who would rather not carry the operational burden, wherever they live.</span>
          </li>
          <li>
            <b>Residential and commercial</b>
            <span>Houses, flats and commercial buildings alike.</span>
          </li>
        </ul>
        <a className="btn btn-line" href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} data-testid="doors-own-cta">
          Tell us about your property
        </a>
      </div>
    </div>
  </section>
);

export default DoorsSection;
